import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { space, width } from 'styled-system'
import Title from 'elements/Title'
import Label from 'elements/Label'
import Button from 'components/Button'
import { apiBaseURI } from 'utils/api'
import { Google, Wordmark, Outlook } from 'svg'
import theme from '../../../../themes/light'

const LogoContainer = styled.div`
  padding-bottom: 5rem;
`

const Wrapper = styled.div`
  max-width: 342px;
  padding-bottom: 5rem;
`

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
`

const OrLabel = styled(Label)`
  color: ${theme.colors.gray60};
  font: ${theme.fonts.small};
  padding-top: 1rem;
`

const Terms = styled.p`
  margin-top: auto;
  margin-bottom: auto;
  color: ${theme.colors.gray60};
  font: ${theme.fonts.small};
  text-align: left;
  ${space}
  ${width}
`

class Login extends Component {
  UNSAFE_componentWillMount () {
    document.title = 'Interseller | Login'
  }

  UNSAFE_componentWillReceiveProps (newProps) {
    const {
      magic
    } = newProps
    const {
      router
    } = this.props

    const email = magic.getIn(['data', 'email'])

    if (email) {
      router.push('/login/magic')
    }
  }

  render () {
    const {
      discovery,
      signup,
      actions
    } = this.props
    const email = discovery.getIn(['data', 'email'])
    const showMagicLink = email && !signup

    const verb = signup ? 'up' : 'in'
    const redirect = `${window.location.protocol}//${window.location.hostname + (window.location.port ? `:${window.location.port}` : '')}`
    const label = `Please select an option to sign ${verb} using your email account.`

    return (
      <Wrapper>
        <LogoContainer>
          <Wordmark />
        </LogoContainer>
        <Title>{`Sign ${verb} with your email account`}</Title>
        <Label mt='1rem'>{label}</Label>
        <ButtonContainer>
          <Button
            ref={(button) => { this.googleButton = button }}
            full
            bg={theme.colors.white}
            borderColor={theme.labelColor}
            label='Sign in with Google'
            icon={<Google />}
            handleClick={() => {
              window.location = `${apiBaseURI}/auth/google/basic?redirect=${redirect}`
            }}
          />
          <Button
            ref={(button) => { this.outlookButton = button }}
            primary
            full
            mt='1rem'
            bg={theme.colors.outlook}
            label='Sign in with Outlook 365'
            icon={<Outlook />}
            handleClick={() => {
              window.location = `${apiBaseURI}/auth/microsoft?redirect=${redirect}`
            }}
          />
          {showMagicLink &&
            <OrLabel align='center'>- or -</OrLabel>}
          {showMagicLink &&
            <Button
              ref={(button) => { this.nylasButton = button }}
              primary
              full
              mt='1rem'
              bg={theme.containerBackground}
              color={theme.primaryColor}
              label='Send Magic Link via Email'
              handleClick={() => {
                actions.fetchEmailLink({ email })
              }}
            />}
        </ButtonContainer>
        {showMagicLink &&
          <Terms pt='1rem'>Magic links let you sign in to your account by just clicking a link in an email sent to your inbox.</Terms>}
      </Wrapper>
    )
  }
}

Login.propTypes = {
  router: PropTypes.object,
  discovery: PropTypes.object,
  signup: PropTypes.any,
  actions: PropTypes.any
}

export default Login
